import { TableRow } from "./DataTable";

/**
 * Adds the one-shot attention glow to the row a navigation pointed at. Kept out of each page's
 * translateFn so a pulse does not change that callback's identity and re-translate every row.
 */
export const withPulsedRow = <IDType extends number | string>(
  rows: TableRow<IDType>[],
  pulseRowKey: string | number | null | undefined
): TableRow<IDType>[] => {
  if (pulseRowKey == null) return rows;
  if (!rows.some(row => String(row.id) === String(pulseRowKey))) return rows;

  return rows.map(row => String(row.id) === String(pulseRowKey)
    ? { ...row, rowTailwindClasses: `${row.rowTailwindClasses ?? ""} glow-once`.trim() }
    : row);
};
